/* import __COLOCATED_TEMPLATE__ from './radio.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-radio';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_HOVER = `${CLASS_NAME}--hover`;

/** @type {object} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
};

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

class GlmRadio extends Component {
  @tracked isHovering = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.disabled && CLASS_NAME_DISABLED,
      this.isHovering && CLASS_NAME_HOVER,
      this.theme,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get theme() {
    const { theme } = this.args;
    return THEME_TO_CLASS_MAP[theme || THEMES.BLACK];
  }

  /**
   * @param {MouseEvent} e
   */
  @action
  handleClick({ target }) {
    this.args.onclick?.(target.value);
  }

  /**
   *
   */
  @action
  onMouseEnter() {
    this.isHovering = true;

    this.args.mouseenter?.();
  }

  /**
   *
   */
  @action
  onMouseLeave() {
    this.isHovering = false;

    this.args.mouseleave?.();
  }
}

export default GlmRadio;
